export { default } from './TabbedContent';
